export default __webpack_public_path__ + "static/media/slide2.86143de3.jpg";